import { CheckConditionalityHelper } from "pages/checks/templates/builder/preview/CheckConditionalityHelper";

export const CheckCompletionStatsHelper = {
    getCompletionStatsForSectionsAndQuestions(components, answers) {
        const stats = {
            count: 0,
            answeredCount: 0
        }
        
        for (const component of components) {
            const componentStats = this.getStatsForComponent(component, answers, components);
            this.combineStats(stats, componentStats);
        }

        return stats;
    },

    getCompletionStatsForSection(section, answers) {
        const stats = {
            count: 0,
            answeredCount: 0
        }

        for (const component of section.childComponents) {
            const componentStats = this.getStatsForComponent(component, answers, section.childComponents);
            this.combineStats(stats, componentStats);
        }

        return stats;
    },

    getStatsForComponent(component, answers, childComponents) {
        const stats = {
            count: 0,
            answeredCount: 0
        };

        if (!CheckConditionalityHelper.shouldComponentShow(component, answers, childComponents)) {
            return stats;
        }

        if (component.$componentType !== "StandardContainer" && component.$componentType != null) {
            if (component.repeatability != null) {
                const repeatableStats = this.getStatsForAnswersWithinRepeatableQuestion(component, answers);
                this.combineStats(stats, repeatableStats);
            }
            else {
                stats.count = stats.count + 1;
                stats.answeredCount = stats.answeredCount + (this.isQuestionAnswered(component, answers) ? 1 : 0);
            }
        } else if (component.repeatability != null) {
            const repeatableStats = this.getStatsForAnsweredQuestionsWithinRepeatableSection(component, answers);
            this.combineStats(stats, repeatableStats);
        } else {
            const statsForChild = this.getCompletionStatsForSection(component, answers);
            this.combineStats(stats, statsForChild);
        }

        return stats;
    },

    getStatsForAnsweredQuestionsWithinRepeatableSection(component, answers) {
        const stats = {
            count: 0,
            answeredCount: 0
        }

        const repeatedAnswersForComponent = this.getRepeatableAnswersForContainer(component, answers);

        for (const repeat of repeatedAnswersForComponent) {
            const statsForRepeat = this.getCompletionStatsForSection(component, [...answers.filter(x => x.$answerType !== "Repeatable"), ...repeat.answers]);

            this.combineStats(stats, statsForRepeat);
        }

        const numberOfAdditionalComponentsNeeded = component.repeatability.minimumNumberOfRepeats - repeatedAnswersForComponent.length + 1;

        if (numberOfAdditionalComponentsNeeded > 0) {
            let numberOfQuestionsInComponent = this.getCompletionStatsForSection(component, []).count;
            if (!numberOfQuestionsInComponent) {
                // Add dummy questions if there are not any, just to ensure they do have to repeat section
                numberOfQuestionsInComponent++;
            }
            stats.count = stats.count + (numberOfAdditionalComponentsNeeded * numberOfQuestionsInComponent);
        }

        return stats;
    },

    getStatsForAnswersWithinRepeatableQuestion(question, answers) {
        const stats = {
            count: 0,
            answeredCount: 0
        }

        const repeatedAnswersForComponent = this.getRepeatableAnswersForQuestion(question, answers);
        const repeatedAnswers = repeatedAnswersForComponent ? repeatedAnswersForComponent.answers : [];

        for (const repeat of repeatedAnswers) {
            stats.count = stats.count + 1;
            stats.answeredCount = stats.answeredCount + (this.isQuestionAnswered(question, [repeat]) ? 1 : 0);
        }

        const numberOfAdditionalQuestionsNeeded = question.repeatability.minimumNumberOfRepeats - repeatedAnswers.length + 1;

        if (numberOfAdditionalQuestionsNeeded > 0) {
            stats.count = stats.count + numberOfAdditionalQuestionsNeeded;
        }

        return stats;
    },

    isQuestionAnswered(question, answers) {
        const answer = answers.find(a => a.questionId === question.id);

        if (!question.required) {
            return answer ? !answer.notValid : false;
        }

        return answer ? answer.isAnswered && !answer.notValid : false;
    },

    getRepeatableAnswersForContainer(section, answers) {
        return answers.filter(a => a.$answerType === 'Repeatable' && a.containerId === section.id);
    },

    getRepeatableAnswersForQuestion(question, answers) {
        return answers.find(a => a.$answerType === 'Repeatable' && a.questionId === question.id);
    },

    combineStats(target, source) {
        target.count = target.count + source.count;
        target.answeredCount = target.answeredCount + source.answeredCount;
    }
}